module.exports = __webpack_public_path__ + "img/xianrou.06ec8c58.jpg";